import { createClient } from '@supabase/supabase-js';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase/client';
import { supabaseFreeTable } from '../utils/supabase/clientFreeTable';
import { useAuth } from './AuthProvider';




export const useRestaurant = () => {
    const {profile} = useAuth(); 
  
  return useQuery({
    queryKey: ['restaurant'],
    queryFn: async () => {
      const { data, error } = await supabaseFreeTable
        .from('restaurants')
        .select('*').eq("id",profile.restaurantid).single();
      if (error) throw error;

      // Ensure name and status are never null
      return data; 
    },
    enabled: !!supabase.auth.getSession(),
  });
};


export const useUpdateRestaurant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    async mutationFn({ id, data }) {
      // Filter out undefined fields to prevent overwriting with null
      const updateData = {
        mainImage: data.mainImage,
        images: data.images,
        name: data.name,
        details: data.details,
        maximumGuests: data.maximumGuests,
        lokacii: data.lokacii,
        location: data.location,
        mapslink: data.mapslink,
        menuUrl: data.menuUrl,
        category1: data.category1,
        category2: data.category2,
        reservationFrom: data.reservationFrom,
        reservationTo: data.reservationTo,
        discount: data.discount,
        eventsonly: data.eventsonly,
        blocked_days: data.blocked_days,
        blocked_dates: data.blocked_dates,
        isDarkMode: data.isDarkMode,
        mainColor: data.mainColor,
        secondaryColor: data.secondaryColor,
        contactInfo: data.contactInfo,
        acceptsOnline: data.acceptsOnline,
        working_hours: data.workingHours,
        cancellationPolicy:data.cancellationPolicy,
        height:data.height,
        width:data.width,
        fontColor:data.fontColor, 
        minimum_age:data.minimum_age,
        event_dates:data.event_dates, 
        noShowPolicy:data.noShowPolicy,
        planSections:data.planSections,
        lokaciiavailability:data.lokaciiAvailability,
        eventsOnlyOnline:data.eventsOnlyOnline

      };

      const { data: updatedData, error } = await supabaseFreeTable
        .from('restaurants')
        .update(updateData)
        .eq('id', id)
        .select()
        .single();

      if (error) {
        throw new Error(error.message);
      }

      return updatedData;
    },
    async onSuccess(_, { id }) {
      await queryClient.invalidateQueries(['restaurants', id]);
    },
    onError(error) {
      console.error('Update restaurant error:', error.message);
      // Optionally, return an error object for EditScreen.js to handle
      return { error: 'Failed to update restaurant' };
    },
  });
};



export const useDeleteRestaurantImageFromBucket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    async mutationFn({ imageLocation }) {
      const { data, error } = await supabaseFreeTable.storage
        .from('restoranisliki')
        .remove([imageLocation]);

      if (error) {
        throw error;
      }
      return data;
    },
    async onSuccess() {
      await queryClient.invalidateQueries(['restaurants']);
    },
    onError(error) {
      console.error('Error deleting image:', error);
    },
  });
};

export const useDeleteMainImageDatabase = () => {
  const queryClient = useQueryClient();

  return useMutation({
    async mutationFn({ id, mainImage }) {
      const { data, error } = await supabaseFreeTable
        .from('restaurants') // Adjust table name as needed
        .update({ mainImage })
        .eq('id', id);

      if (error) {
        throw error;
      }
      return data;
    },
    async onSuccess() {
      await queryClient.invalidateQueries(['restaurants']);
    },
    onError(error) {
      console.error('Error updating mainImage in database:', error);
    },
  });
};